export const SAME_NAME_WARNING =
  "Warning! This name is already being used by a different coach.";
  export const SAME_NAME_WARNING_AD =
  "Warning! This name is already being used by a different AD.";
export const SIMILAR_NAME_WARNING =
  "Warning! This name is similar to another coach's name.";
export const SIMILAR_NAME_WARNING_AD =
  "Warning! This name is similar to another AD's name.";
export const COACH_DEACTIVATION_CONFIRMATION =
  "Are you sure you want this coach to be deactivated?";
  export const COACH_DEACTIVATION_CONFIRMATION_AD =
  "Are you sure you want this AD to be deactivated?";
export const COACH_DELETION_CONFIRMATION =
  "Are you sure you want to delete this coach?";
  export const COACH_DELETION_CONFIRMATION_AD =
  "Are you sure you want to delete this AD?";
export const COACH_EDIT_CONFIRMATION = "Do you want to edit existing coach?";
export const COACH_EDIT_CONFIRMATION_AD = "Do you want to edit existing AD?";

export const COACH_DELETION_INSTRUCTIONS = "Type the coach name to delete";
export const COACH_DELETION_INSTRUCTIONS_AD = "Type the AD name to delete";
export const COACH_NAME_PREFACE = "Coach Name:";
export const COACH_NAME_PREFACE_AD = "AD Name:";

export const EDIT_COACH = "Edit Coach";
export const EDIT_AD = "Edit AD";
export const NEW_COACH = "New Coach";

export const UPDATE_COACH_BUTTON_LABEL = "Change Coach";
export const CREATE_COACH_BUTTON_LABEL = "Add New Coach";

export const ACTIVE_GROUP = "Active:";

export const SPORT_SELECTION_LABEL = "Sport";
export const COACH_TEXT_FIELD_LABEL = "Name";

export const DELETE_COACH_BUTTON_LABEL = "Delete";
export const CLOSE_MODAL_BUTTON_LABEL = "Close";



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/edit-coach-modal/constants.ts